import React, {useEffect, useRef, useState} from 'react';
import {Form, message,} from 'antd';
import {ProFormInstance} from '@ant-design/pro-form';
import {wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {WdiSelect, WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {Enum} from '@/enums/system';
import {Supplier} from '@/services/mdm/supplier';
import {FormSpMkt} from "@/services/mkt/sp";
import {Company} from "@/services/mdm/company";
import {DataOptions} from "@/services/basic/metadata";
import {Staff} from "@/services/basic/staff";

const PaymentPrevApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [companyCode, setCompanyCode] = useState<string>();
  const [currentStaff, setCurrentStaff] = useState<API.Staff>()
  const [payToTypeId, setPayToTypeId] = useState<number>(0);

  useEffect(() => {

  }, [props.id]);
  useEffect(() => {
    (async () => {
      const resp = await Staff.current();
      setCurrentStaff(resp.data);
    })()
  }, []);
  const handlePayToTypeChange = (value: number) => {
    setPayToTypeId(value);
    formRef.current?.setFieldsValue({
      payToUserId: {
        value: currentStaff?.staffId,
        label: wdiCore.String.GenerateLabelDescription(currentStaff?.staffNoOrName, currentStaff?.title)
      }
    })
  }
  return (
    <WdiModalForm
      formRef={formRef}
      initialValues={{paymentMethodName: "第三方付款(给供应商/员工)"}}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose ? props.onClose() : null
        },
        okText: '下一步'
      }}
      {...HorzLayoutOpts}
      onFinish={async (values) => {
        const {supplierId, companyCode, payToUserId, payToTypeId} = values;
        const entity = {
          formSaMktId: Number(props.id),
          paymentMethodId: Enum.PaymentMethod.THIRD_PART,
          formTypeId: Enum.FormType.ACTIVITY_MKT_PAYMENT,
          pageTypeId: Enum.PageType.PAYMENT_MKT,
          reimburseType: 1,
          companyCode: WdiSelectFormat.getvalue(companyCode),
          supplierId: WdiSelectFormat.getvalue(supplierId),
          payToUserId: WdiSelectFormat.getvalue(payToUserId),
          payToTypeId: WdiSelectFormat.getvalue(payToTypeId),
        };
        const response: any = await FormSpMkt.paymentMktPrev(entity);
        if (response.code != ResponseStatus.SUCCESS) {
          message.error(response.message);
        } else {
          if (props.onSave) {
            props.onSave(response);
          }
        }
      }}
    >
      <Form.Item
        name='payToTypeId'
        label='支付给'
        rules={[{required: true, message: '支付给不能为空!'}]}
      >
        <WdiSelect {...{
          //disabled: paymentMethodId != Enum.PaymentMethod.THIRD_PART,
          placeholder: '请选择支付给',
          dataLoading: async () => {
            const params: API.DataOptionsFilter = {typeGroup: 172,};
            params.notInValues = String(Enum.PayToType.PAY_TO_SOLD_TO);
            const response = await DataOptions.search(params);
            return response.data?.map((item) => ({label: item.name, value: item.value}));
          },
          onChange: (value) => {
            handlePayToTypeChange(value);
          }
        }} />
      </Form.Item>
      <Form.Item name='companyCode' label='公司' rules={[{required: true, message: '公司不能为空'}]}>
        <WdiSelect
          {...{
            placeholder: '请选择公司',
            showSearch: true,
            dataLoading: async (params) => {
              const response = await Company.search(Object.assign({formSaMktId: Number(props.id)}, params));
              return response.data.map((item) => {
                return {
                  value: item.companyCode,
                  label: wdiCore.String.CodeOrName(item.companyCode, item.companyName)
                };
              });
            },
            onChange: (params) => {
              setCompanyCode(params)
            }
          }} />
      </Form.Item>
      {payToTypeId == Enum.PayToType.PAY_TO_SUPPLIER && (<Form.Item
          name="supplierId"
          label="供应商"
          rules={[{required: true, message: '供应商不能为空!'}]}>
          <WdiSelect {...{
            placeholder: "请选择供应商",
            remote: true,
            defaultParamKey: "supplierIds",
            showSearch: true,
            reloadKey: companyCode,
            dataLoading: async (params) => {
              const response = await Supplier.ajaxSearch(Object.assign({
                isActive: true,
                companyCode: companyCode
              }, params));
              return response.data.map((item) => {
                return {value: item.supplierId, label: item.codeOrName};
              });
            }
          }} />
        </Form.Item>
      )}
      {payToTypeId == Enum.PayToType.PAY_TO_STAFF && (
        <Form.Item
          name="payToUserId"
          label="员工"
          rules={[{required: true, message: '员工不能为空!'}]}>
          <WdiSelect {...{
            placeholder: "请选择员工",
            showSearch: true,
            remote: true,
            dataLoading: async (params) => {
              const response = await Staff.ajaxSearch(Object.assign({isActive: true}, params));
              return response?.data.map((item: any) => ({
                value: item.staffId,
                label: wdiCore.String.GenerateLabelDescription(item.staffNoOrName, item.title,),
              }));
            }
          }} />
        </Form.Item>
      )}
    </WdiModalForm>
  );
};
export default PaymentPrevApp;
